import { useLayoutEffect } from 'react';
import './App.scss';
import createApiInstance from './services/api';
import { isProduction } from './constants';
import Spin from 'antd/es/spin';
import { Layout, Space } from 'antd';
import { useInfoData } from './hooks/useInfoData';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Body from './components/Body';
import Breadcrumbs from './components/Breadcrumbs';

const { Content } = Layout;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const LoadingLayout = () => (
  <div className="microfront-name__loading-react-app">
    <Spin size="large" />
  </div>
);

const App = (): JSX.Element => {
  const { infoData } = useInfoData();

  useLayoutEffect(() => {
    if (Object.keys(infoData).length > 0) {
      createApiInstance(infoData);
    }
  }, [infoData]);

  return Object.keys(infoData).length > 0 ? (
    <QueryClientProvider client={queryClient}>
      <Layout className={`microfront-name ${isProduction ? 'production' : ''}`}>
        <Content className="microfront-name__content">
          <Breadcrumbs data={['labels.breadcrumb.home', 'labels.breadcrumb.title']} />
          <Space direction="vertical" size={'middle'} className="microfront-name__site-layout-content">
            <Body />
          </Space>
        </Content>
      </Layout>
      <ReactQueryDevtools />
      {!isProduction && <ReactQueryDevtools />}
    </QueryClientProvider>
  ) : (
    <LoadingLayout />
  );
};

export default App;
